import jsonData from '../../data.json';

function useSideBarData() {

    const sideBarBoards = jsonData?.boards.map(item => item.name) || [];
    console.log("sideBarBoards: ", sideBarBoards)
    return { sideBarBoards };
}

export default useSideBarData